<template>
  <Block
    type="accountSetting"
    id="safeQuession"
    style="padding-top: 0"
    class="find-pwd-container"
  >
    <common-header
      is-passport
      :show-lang="false"
      :title="languages.findPwd"
    ></common-header>
    <transition name="fade">
      <div
        class="check-account-step"
        :class="$platformClass"
        v-show="waysControllers[STEP_CHECK_ACCOUNT]"
      >
        <Content
          type="passportTips"
          :class="$platformClass"
          class="quession-title"
        >
          {{ languages.findPwdTips }}
        </Content>
        <form class="quession-form mt20">
          <Editor
            v-model="userName"
            editorClass="editor safe-input"
            class="editor-wrapper relative"
            :class="$platformClass"
            type="passportAccountEditor"
            :placeholder="languages.accountName"
          ></Editor>

          <Block
            type="editorWrapper"
            class="editor-wrapper relative"
            :class="$platformClass"
          >
            <input
              type="text"
              class="editor safe-input"
              :class="$platformClass"
              v-model="vrCode"
              :placeholder="languages.editVrfCodeTips"
            />
            <div class="vrfcode-contianer" :class="$platformClass">
              <img class="vrfcode" :src="vfrcodePath" />
              <Button
                class="refresh-code-btn"
                @click="getNewVrfCode"
                type="refresh"
              ></Button>
            </div>
          </Block>
          <div
            v-if="isRecaptcha"
            id="recaptcha"
            class="google-vertify g-recaptcha"
          ></div>
          <label class="agree-wrapper mt20" :class="$platformClass">
            <Button
              @click="checkEmail"
              data-asyncbtn
              class="btn account-setting-submit"
              type="lightfill"
            >
              <Icon type="commonBtnLeft"></Icon>
              <Icon type="commonBtnRight"></Icon>
              {{ languages.submit }}
            </Button>
          </label>
        </form>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="select-way-step"
        :class="$platformClass"
        v-show="waysControllers[STEP_SELECT_WAY]"
      >
        <p class="quession-title grayBorderBtm mb20" :class="$platformClass">
          {{ languages.findPwdWayTips }}
        </p>
        <ul class="ways">
          <li class="find-way mb40" v-if="bindedEmail">
            <div class="way-text" :class="$platformClass">
              <p class="mb10">{{ languages.emailWay }}</p>
              <p>{{ languages.emailWayTips }}</p>
            </div>
            <Button
              type="selectResetPwd"
              class="select-way-btn"
              @click="selectWay('email')"
            >
              {{ languages.resetPwdBtn }}
            </Button>
          </li>
          <li class="find-way mb40" v-if="securityQuessions.length > 0">
            <div class="way-text" :class="$platformClass">
              <p class="mb10">{{ languages.quessionWay }}</p>
              <p>{{ languages.quessionWayTips }}</p>
            </div>
            <Button
              type="selectResetPwd"
              class="select-way-btn"
              data-asyncbtn
              @click="selectWay('quession')"
            >
              {{ languages.resetPwdBtn }}
            </Button>
          </li>
        </ul>
        <a
          :href="accountFixedLink"
          class="account-fixed-link account-fixed"
          :class="$platformClass"
          v-html="languages.applyFixAccount || 'Account Recovery'"
        ></a>
        <button
          class="previous-btn"
          :class="$platformClass"
          @click="showStep(STEP_CHECK_ACCOUNT)"
        >
          {{ languages.lastStep }}
        </button>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="quession-way-step"
        :class="$platformClass"
        v-show="waysControllers[STEP_SHOW_QUESSION_WAY]"
      >
        <p class="quession-title find-pwd" :class="$platformClass">
          {{ languages.securityQuestionTips }}
        </p>
        <ValidateQuession
          :extendParam="{ uname: userName }"
          :validateQuessions="securityQuessions"
          :quessionRef="FIND_PWD_REF"
          v-on:validateSuccess="setValidateToken"
          @showErrorTips="showErrorTips"
        ></ValidateQuession>
        <button
          class="previous-btn"
          :class="$platformClass"
          @click="showStep(STEP_SELECT_WAY)"
        >
          {{ languages.lastStep }}
        </button>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="email-way-step"
        :class="$platformClass"
        v-show="waysControllers[STEP_SHOW_EMAIL_WAY]"
      >
        <p
          class="quession-title mb20"
          :class="$platformClass"
          v-html="languages.sendEmailTips.replace('$email', email)"
        ></p>
        <form class="quession-form">
          <Editor
            v-model="emaileCode"
            editorClass="editor safe-input"
            class="editor-wrapper relative"
            type="passportAccountEditor"
            :placeholder="languages.editVrfCodeTips"
          ></Editor>
          <label class="agree-wrapper mt20" :class="$platformClass">
            <Button
              class="btn account-setting-submit"
              data-asyncbtn
              @click="postEmailVrCode"
              type="lightfill"
            >
              <Icon type="commonBtnLeft"></Icon>
              <Icon type="commonBtnRight"></Icon>
              {{ languages.submit }}
            </Button>
          </label>
        </form>
        <button
          class="previous-btn"
          :class="$platformClass"
          @click="showStep(STEP_SELECT_WAY)"
        >
          {{ languages.lastStep }}
        </button>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="reset-step"
        :class="$platformClass"
        v-show="waysControllers[STEP_RESET_PWD]"
      >
        <Content
          type="passportTips"
          class="quession-title"
          :class="$platformClass"
          v-html="languages.setNewPwdTips"
        ></Content>
        <form class="quession-form">
          <Editor
            v-model="password"
            editorClass="editor safe-input"
            class="editor-wrapper relative"
            editorType="password"
            type="passportAccountEditor"
            :placeholder="languages.password"
          ></Editor>
          <Editor
            v-model="repeatPwd"
            editorClass="editor safe-input"
            class="editor-wrapper relative"
            editorType="password"
            type="passportAccountEditor"
            :placeholder="languages.repeatPassword"
          ></Editor>

          <label class="agree-wrapper mt20" :class="$platformClass">
            <Button
              class="btn account-setting-submit"
              data-asyncbtn
              type="lightfill"
              @click="resetPwd"
            >
              <Icon type="commonBtnLeft"></Icon>
              <Icon type="commonBtnRight"></Icon>
              {{ languages.submit }}
            </Button>
          </label>
        </form>
        <button
          class="previous-btn"
          :class="$platformClass"
          @click="showStep(selectedWay)"
        >
          {{ languages.lastStep }}
        </button>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="reset-step mt100"
        :class="$platformClass"
        v-if="waysControllers[STEP_RESET_SUCCESS]"
      >
        <i class="resetPwdSuccess" :class="$platformClass"></i>
        <p class="success-tips" v-html="successTips"></p>
      </div>
    </transition>
    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
    <transition name="fade">
      <Tost v-show="showTost"></Tost>
    </transition>
    <!-- <Popup :title="languages.tips" :cancel="languages.cancel" :confirm="languages.confirm"></Popup> -->
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="languages"
      :content="errTips"
    ></PopupWindow>
    <PopupWindow
      @onCancel="showFixAccountTips = false"
      @onConfirm="redirectToFixAccount()"
      type="tips"
      v-if="showFixAccountTips"
      :languages="languages"
      :content="fixAccountTips"
    ></PopupWindow>
  </Block>
</template>
<script>
import {
  CHECK_ACCOUNT,
  SEND_VRFCODE_EMAIL,
  VALIDATE_EMAIL_VRCODE,
  RESET_PWD
} from '../../store/passport/findPassword';
import { FIND_PWD_REF } from '../../store/passport/accountSetting';
import AccountSettingMixins from '../../mixins/AccountSetting';
import globalConfig from '../../utiles/globalConfig';
import ValidateQuession from '../../components/passport/ValidateQuession';
import commonHeader from '@/resource/components/support/header';
import * as ultile from '../../store/ultile';
import languages from '../../store/languages';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const SEARCH = globalConfig.getLocationSearch();
const MAIN_HOST = globalConfig.getMainHost();
const BASE_PATH = `//gpassport.${MAIN_HOST}/center/ajax/get_code?${SEARCH}&v=`;
const STEP_CHECK_ACCOUNT = 'step1';
const STEP_SELECT_WAY = 'step2';
const STEP_SHOW_EMAIL_WAY = 'step3';
const STEP_SHOW_QUESSION_WAY = 'step4';
const STEP_RESET_PWD = 'step5';
const STEP_RESET_SUCCESS = 'step6';
const FIND_PWD_FAIL = 'findPasswordFail';
/* eslint-disable no-unused-vars */
let sendingEmail = false;
export default {
  name: 'bindEmail',
  data() {
    return {
      userName: '',
      vrCode: '',
      email: '',
      emaileCode: '',
      showFixAccountTips: false,
      fixAccountTips: '',
      vfrcodePath: BASE_PATH + new Date().getTime(),
      answers: [],
      STEP_CHECK_ACCOUNT,
      STEP_SELECT_WAY,
      STEP_SHOW_EMAIL_WAY,
      STEP_SHOW_QUESSION_WAY,
      STEP_RESET_PWD,
      STEP_RESET_SUCCESS,
      password: '',
      repeatPwd: '',
      selectedWay: '',
      waysControllers: {
        [STEP_CHECK_ACCOUNT]: true,
        [STEP_SELECT_WAY]: false,
        [STEP_SHOW_EMAIL_WAY]: false,
        [STEP_SHOW_QUESSION_WAY]: false,
        [STEP_RESET_PWD]: false,
        [STEP_RESET_SUCCESS]: false
      },
      lastStep: STEP_CHECK_ACCOUNT,
      resetSuccess: false,
      successTips: '',
      resetToken: '',
      FIND_PWD_REF,
      isRecaptcha: false,
      recaptchaToken: ''
    };
  },
  beforeCreate() {
    globalConfig.storeEntryParams();
    sendingEmail = false;
  },
  created() {
    this.$isOmni && this.initLandscapeWidthFit();
  },
  computed: {
    securityQuessions() {
      return this.$store.state.findPassword.securityQuessions;
    },
    bindedEmail() {
      return this.$store.state.findPassword.bindedEmail;
    },
    accountFixedLink() {
      let languagePreset = [
        'zh-CN',
        'zh-TW',
        'en-US',
        'vi-VN',
        'th-TH',
        'ko-KR'
      ];
      let language = ultile.getHrefParam('language');
      let appLanguage = ultile.getHrefParam('appLanguage');
      let gameId = ultile.getHrefParam('gameId');

      language = languagePreset.indexOf(language) > -1 ? language : 'en-US';
      appLanguage =
        languagePreset.indexOf(appLanguage) > -1 ? appLanguage : 'en-US';
      return getGlobalGetGotoLink({ link:  `//pay.${MAIN_HOST}/platform/repairedAccount.html#/?user_account=${this.userName}&language=${language}&appLanguage=${appLanguage}&gameId=${gameId}`});
    }
  },
  watch: {
    securityQuessions(quessions) {
      let len = quessions.length;
      this.answers = [];
      for (let i = 0; i < len; i++) {
        let answer = {
          id: quessions[i].id,
          answer: ''
        };
        this.answers.push(answer);
      }
    }
  },
  methods: {
    getNewVrfCode() {
      this.vfrcodePath = BASE_PATH + new Date().getTime();
    },

    showStep(step) {
      this.waysControllers[this.lastStep] = false;
      setTimeout(() => {
        this.waysControllers[step] = true;
        this.lastStep = step;
      }, 500);
    },

    checkEmail() {
      this.$store
        .dispatch(CHECK_ACCOUNT, {
          uname: this.userName,
          ckcode: this.vrCode,
          FIND_PWD_FAIL,
          google_recaptcha_token: this.isRecaptcha ? this.recaptchaToken : '',
          isRecaptcha: this.isRecaptcha
        })
        .then(result => {
          this.getNewVrfCode();
          this.isRecaptcha && this.resetRecaptcha();
          if (result.success) {
            this.showStep(STEP_SELECT_WAY);
          } else {
            if (
              result.res &&
              result.res.result &&
              result.res.result == '-900423' &&
              this.checkOpenRecaptcha()
            ) {
              this.loadRecaptcha();
            }
            if (result.type === 'findPwdByFixAccount') {
              this.showFixAccountTips = true;
              this.fixAccountTips = result.errmsg;
            } else {
              this.showErrorTips(result.errmsg);
            }
          }
        })
        .catch(err => {
          this.showErrorTips(err.message);
        });
    },

    redirectToFixAccount() {
      let languagePreset = [
        'zh-CN',
        'zh-TW',
        'en-US',
        'vi-VN',
        'th-TH',
        'ko-KR'
      ];
      let language = ultile.getHrefParam('language');
      let appLanguage = ultile.getHrefParam('appLanguage');
      let gameId = ultile.getHrefParam('gameId');

      language = languagePreset.indexOf(language) > -1 ? language : 'en-US';
      appLanguage =
        languagePreset.indexOf(appLanguage) > -1 ? appLanguage : 'en-US';
      window.location.href = getGlobalGetGotoLink({
        link: `//pay.${MAIN_HOST}/platform/repairedAccount.html#/?user_account=${this.userName}&language=${language}&appLanguage=${appLanguage}&gameId=${gameId}`
      });
    },

    selectWay(way) {
      if (way == 'email') {
        sendingEmail = true;
        this.$store
          .dispatch(SEND_VRFCODE_EMAIL, this.userName)
          .then(email => {
            if (email !== '' || undefined !== email) {
              this.email = email;
              this.showStep(STEP_SHOW_EMAIL_WAY);
              this.selectedWay = STEP_SHOW_EMAIL_WAY;
            }
            sendingEmail = false;
          })
          .catch(err => {
            this.showErrorTips(err.message);
          });
      } else {
        this.showStep(STEP_SHOW_QUESSION_WAY);
        this.selectedWay = STEP_SHOW_QUESSION_WAY;
      }
    },
    setValidateToken(token) {
      this.resetToken = token;
      this.showStep(STEP_RESET_PWD);
    },
    postEmailVrCode() {
      this.$store
        .dispatch(VALIDATE_EMAIL_VRCODE, {
          userName: this.userName,
          ckcode: this.emaileCode
        })
        .then(success => {
          if (success) {
            this.resetToken = success;
            this.showStep(STEP_RESET_PWD);
          }
        })
        .catch(err => {
          this.showErrorTips(err.message);
        });
    },

    resetPwd() {
      this.$store
        .dispatch(RESET_PWD, {
          uname: this.userName,
          password: this.password,
          repassword: this.repeatPwd,
          token: this.resetToken
        })
        .then(successTips => {
          if (successTips) {
            this.successTips = successTips;
            this.showStep(STEP_RESET_SUCCESS);
          }
        })
        .catch(err => {
          this.showErrorTips(err.message);
        });
    },
    initLandscapeWidthFit() {
      document.querySelector('html').classList.add('width-100vw');
      document.querySelector('body').classList.add('width-100vw');
    },
    checkOpenRecaptcha() {
      const gameId = +ultile.getHrefParam('gameId');
      const openGameId = [161];
      if (openGameId.includes(gameId)) {
        this.isRecaptcha = true;
        return true;
      }
      return false;
    },
    loadRecaptcha() {
      const self = this;
      window.recaptchaOnloadCallback = function () {
        if (document.getElementById('recaptcha')) {
          grecaptcha.render('recaptcha', {
            sitekey: '6Ld6ALMjAAAAAFwBqif_itYtLZhJG1VZEbXQIzNy',
            callback: function (token) {
              self.recaptchaToken = token;
            }
          });
        }
      };
      (function (d, s) {
        let f = d.getElementsByTagName(s)[0],
          j = d.createElement(s);
        j.async = true;
        j.src =
          'https://www.google.com/recaptcha/api.js?onload=recaptchaOnloadCallback&render=explicit&hl=' +
            languages.getLanguage() || 'en-US';
        f.parentNode.insertBefore(j, f);
      })(document, 'script');
    },
    resetRecaptcha() {
      grecaptcha.reset();
      this.recaptchaToken = '';
    }
  },
  mixins: [AccountSettingMixins],
  components: {
    commonHeader,
    ValidateQuession
  }
};
</script>

<style scoped lang="scss">
.google-vertify {
  display: block;
  padding: 0 15px;
  height: 78px;
  margin-top: 5px;
}
</style>
